import { overrides as componentOverrides } from './overrides';
import { createTheme } from '@lifeomic/chroma-react/styles';
import { ColorMode } from '../../redux/modules/colorMode/reducer';
import { getPaletteForColorMode } from './palette';

const sharedThemeOptions = {
  components: componentOverrides,
  typography: {
    fontFamily: '"Work Sans", "Roboto", sans-serif',
    // Add Work Sans as secondary font as well so Chroma's default
    // secondary font is not used anywhere in this app
    fontFamilySecondary: '"Work Sans", "Roboto", sans-serif',
  },
};

export const createPhcTheme = (mode: ColorMode = 'light') =>
  createTheme({
    ...sharedThemeOptions,
    palette: getPaletteForColorMode(mode),
  });

export const theme = createPhcTheme('light');
